import { Row, Col, Card, Typography, Descriptions, Button, Modal } from "antd";
import { useEffect, useState } from "react";
import { getDeviceDetailsAPI, updateDeviceStatusAPI } from "../api/devices";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import {
  ArrowLeftOutlined,
  EnvironmentOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";

const { Title } = Typography;

function DeviceDetails() {
  const [device, setDevice] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    _getDeviceDetails(window.history.state?.usr?.device_id);
  }, [window.history.state?.usr?.device_id]);

  const _getDeviceDetails = async (id) => {
    const res = await getDeviceDetailsAPI(id);
    if (res?.statusCode === 200) {
      setDevice({
        ...res?.data?.records[0],
        temp_in_f: res?.data?.records[0]?.last_temp?.temp_in_f,
        temp_created_at: res?.data?.records[0]?.last_temp?.created_at,
      });
    }
  };

  const openGoogleMaps = (lat, long) => {
    const url = `https://www.google.com/maps?q=${lat},${long}`;
    window.open(url, "_blank");
  };

  const handleResetMeal = () => {
    Modal.confirm({
      title: "Reset Meal",
      content: "Do you want to reset meal?",
      okText: "Yes",
      cancelText: "No",
      onOk: async () => {
        try {
          const res = await updateDeviceStatusAPI(device?.id, {
            water_state: "out",
            device_state: "idle",
            update_source: "app",
          });

          if (res?.statusCode === 200) {
            // Refresh device details after reset
            _getDeviceDetails(device?.id);
          }
        } catch (error) {
          console.log("Error", error);
          Modal.error({
            title: "Error",
            content: error?.message || "Something went wrong.",
          });
        }
      },
      onCancel: () => {
        console.log("Reset meal cancelled");
      },
    });
  };

  const handleFirmwareUpdate = () => {
    Modal.confirm({
      title: "Update Firmware",
      content: "Do you want to update the firmware?",
      okText: "Yes",
      cancelText: "No",
      onOk: async () => {
        try {
          const res = await updateDeviceStatusAPI(device?.id, {
            firmware_update_requested: true,
          });

          if (res?.statusCode === 200) {
            // Refresh device details after update request
            _getDeviceDetails(device?.id);
          }
        } catch (error) {
          console.log("Error", error);
          Modal.error({
            title: "Error",
            content: error?.message || "Something went wrong.",
          });
        }
      },
      onCancel: () => {
        console.log("Firmware update cancelled");
      },
    });
  };

  return (
    <div style={{ padding: 24 }}>
      <Row gutter={[24, 24]}>
        {/* Back Button and Action Buttons Row */}
        <Col span={12} style={{ textAlign: "left" }}>
          <div
            style={{ paddingTop: 10, cursor: "pointer" }}
            onClick={() => navigate(-1)}
          >
            <ArrowLeftOutlined /> Back
          </div>
        </Col>
        <Col span={12} style={{ textAlign: "right" }}>
          <Button
            type="primary"
            onClick={handleFirmwareUpdate}
            style={{ marginTop: 10, marginRight: 8 }}
          >
            Update Firmware
          </Button>
          <Button
            type="primary"
            danger
            onClick={handleResetMeal}
            style={{ marginTop: 10 }}
          >
            Reset Meal
          </Button>
        </Col>

        <Col xs={24} xl={24}>
          <Card bordered={false} className="device-details-card">
            <Title level={3}>Device Information</Title>
            <Descriptions bordered column={1}>
              <Descriptions.Item label="Device ID">
                {device?.id}
              </Descriptions.Item>
              <Descriptions.Item label="Device Name">
                {device?.device_name}
              </Descriptions.Item>
              <Descriptions.Item label="Connection State">
                <span
                  style={{
                    color:
                      device?.device_connection_state === "connected"
                        ? "green"
                        : "red",
                  }}
                >
                  {device?.device_connection_state}
                </span>
              </Descriptions.Item>
              <Descriptions.Item label="Device State">
                {device?.device_state}
              </Descriptions.Item>
              <Descriptions.Item label="Water State">
                {device?.water_state}
              </Descriptions.Item>
              <Descriptions.Item label="No Water Alarm">
                {device?.is_no_water_alarm_on ? "On" : "Off"}
              </Descriptions.Item>
              <Descriptions.Item label="Vacuum State">
                {device?.is_vacuum_on ? "On" : "Off"}
              </Descriptions.Item>
              <Descriptions.Item label="Current Temperature">
                {device?.temp_in_f} °F
              </Descriptions.Item>
              <Descriptions.Item label="Desire Temperature">
                {device?.temperature} °F
              </Descriptions.Item>
              <Descriptions.Item label="Cooking Time">
                {device?.cooking_time} minutes
              </Descriptions.Item>
              <Descriptions.Item label="Firmware Version">
                {device?.firmware_version}
              </Descriptions.Item>
              <Descriptions.Item label="Firmware Update Requested">
                {device?.firmware_update_requested ? "Yes" : "No"}
              </Descriptions.Item>
              <Descriptions.Item label="Mode">
                {device?.device_mode}
              </Descriptions.Item>
              <Descriptions.Item label="Email">
                {device?.email}
              </Descriptions.Item>
              <Descriptions.Item label="Full Name">
                {device?.full_name}
              </Descriptions.Item>
              <Descriptions.Item label="Total Usage">
                {device?.total_usage} times
              </Descriptions.Item>
              <Descriptions.Item label="Created At">
                {moment(device?.created_at).format("LLL")}
              </Descriptions.Item>
              <Descriptions.Item label="Last Updated">
                {moment(device?.updated_at).format("LLL")}
              </Descriptions.Item>
              <Descriptions.Item label="Location">
                {device?.latitude && device?.longitude ? (
                  <>
                    <EnvironmentOutlined style={{ marginRight: 8 }} />
                    {device?.latitude}, {device?.longitude}
                    <ArrowRightOutlined
                      style={{ marginLeft: 8, cursor: "pointer" }}
                      onClick={() =>
                        openGoogleMaps(device?.latitude, device?.longitude)
                      }
                    />
                  </>
                ) : (
                  "N/A"
                )}
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default DeviceDetails;
